import React, { memo } from 'react';

import styled from 'styled-components';
import { MicOff } from 'styled-icons/material/MicOff';
import ProfileImage from '../profile-image';
import { AVLocalVideo, AVRemoteVideo } from '@cuemath/av';

const Wrapper = styled.div`
  position: relative;
  width: auto;
  height: auto;
  border-radius: 10px;
  margin: 1%;
  video {
    border: solid gray 1px;
    height: 100%;
    width: 100%;
    overflow: hidden;
    border-radius: 10px;
  }
`;

const Footer = styled.div`
  position: absolute;
  left: 1rem;
  bottom: 1rem;
  color: #fff;
`;
const VideoContent = styled.div`
  height: 100%;
  width: 100%;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const MicOffIcon = styled(MicOff)`
  position: absolute;
  right: 1rem;
  top: 1rem;
  z-index: 1;
`;

const VideoWrapper = styled.span`
  > div {
    height: 100%;
    > video {
      object-fit: cover;
    }
  }
`;

const LocalVideoWrapper = styled(VideoWrapper)`
  > div {
    > video {
      transform: rotateY(180deg);
    }
  }
`;

const Video = props => {
  const { peer, userDetails, hasAudio, hasVideo, isLocal } = props;

  return (
    <Wrapper>
      {!hasAudio && <MicOffIcon size={20} color="#fff" />}
      {hasVideo &&
        peer &&
        (isLocal ? (
          <LocalVideoWrapper>
            <AVLocalVideo peer={peer} videoType="camera" />
          </LocalVideoWrapper>
        ) : (
          <VideoWrapper>
            <AVRemoteVideo peer={peer} videoType="camera" />
          </VideoWrapper>
        ))}
      {!hasVideo && (
        <VideoContent>
          <ProfileImage name={userDetails.fullName} />
        </VideoContent>
      )}
      <Footer>{userDetails.name}</Footer>
    </Wrapper>
  );
};

export default memo(Video);
